import Paginate from 'vuejs-paginate'
export default {
  name: 'copy-checklist',
  components: {Paginate},
  props: [],
  data () {
    return {
      per_page: 100,
      search: '',
      sort: 'desc',
      status: '',
      normalizer (node) {
        return {
          id: node.id,
          label: node.name,
          children: node.children
        }
      },
      organization_id: null
    }
  },
  computed: {
    checklists () {
      return this.$store.getters['Checklist/getListChecklist']
    },
    last_page () {
      return this.$store.getters['Checklist/getLastPage']
    },
    total () {
      return this.$store.getters['Checklist/getTotal']
    },
    organizations () {
      return this.$store.getters['Organization/getOrganization']
    }
  },
  mounted () {
  
    Promise.all([
      this.$store.dispatch('Checklist/getListChecklist', {page: 1, per_page: 100}),
    ]).then(res => {
      this.$refs.copyChecklistShow.show()
      
    }).catch(errors => {
      
    })
  },
  methods: {
    show () {
      this.$refs.copyModal.show()
    },

    hide () {
      this.$refs.copyModal.hide()
    },

    changeTotal () {
    
      this.$store.dispatch('Checklist/getListChecklist', {page: 1, per_page: this.per_page, status: this.status, sort: this.sort, search: this.search, organization_id: this.organization_id}).then(res => {
        
      }).catch(errors => {
        
      })
    },

    clickCallback (page) {
    
      this.$store.dispatch('Checklist/getListChecklist', {page: page, per_page: this.per_page, status: this.status, sort: this.sort, search: this.search, organization_id: this.organization_id}).then(res => {
        
      }).catch(errors => {
        
      })
    },

    filter () {
    
      this.$store.dispatch('Checklist/getListChecklist', {page: 1, per_page: this.per_page, status: this.status, sort: this.sort, search: this.search, organization_id: this.organization_id}).then(res => {
        
      }).catch(errors => {
        
      })
    },

    copy (checklist) {
      this.$emit('copy', checklist)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/checklist/checklist-item/copy-checklist/copy-checklist.js